import { Component, Input } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LinkEntityType } from '../../enums/LinkEntityType.enum';
import { UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-multiple-file-upload',
    templateUrl: './multiple-file-upload.component.html',
    styleUrls: ['./multiple-file-upload.component.scss'],
})
export class MultipleFileUploadComponent {
    @Input() headingName: string;
    @Input() modalMode: string;
    @Input() linkEntityType: LinkEntityType;
    @Input() linkEntityId: string;

    documentUploadForm: UntypedFormGroup;
    uploadedFile: any = [];

    constructor(
        public modalService: NgbActiveModal,
        private fb: UntypedFormBuilder,
        private user_utilty: UserUtilityService,
        private customToastService: CustomToastService
    ) {
        this.documentUploadForm = this.fb.group({});
    }

    // fileChangeEvent(event: any) {
    //     if (event.target.files) {
    //         for (var i = 0; i < event.target.files.length; i++) {
    //             const allowedTypes = [
    //                 'application/pdf',
    //                 'image/png',
    //                 'image/jpeg',
    //                 'image/jpg',
    //                 'application/vnd.ms-excel',
    //                 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //             ];
    //             let errorMessage = 'Please select a .jpeg, .jpg, .png, .webp, .pdf, .xls, or .xlsx file.';
    //             if (!allowedTypes.includes(event.target.files[i].type)) {
    //                 this.customToastService.errorToast(errorMessage, 'Error');
    //                 return;
    //             }
    //             this.uploadedFile.push(event.target.files[i]);
    //             this.documentUploadForm.addControl(
    //                 event.target.files[i].name,
    //                 new FormControl(event?.target?.files[i]?.name, [Validators.required, Validators.maxLength(255)])
    //             );
    //         }
    //     }
    // }
    fileChangeEvent(event: any): void {
        const files = event?.target?.files;
        if (!files?.length) return;

        const allowedTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/jpg',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        const errorMessage = 'Please select a .jpeg, .jpg, .png, .webp, .pdf, .xls, or .xlsx file.';

        const fileArray = Array.from(files) as File[];

        // ❌ Validate all files — without explicit loop
        const invalidFile = fileArray.find((file) => !allowedTypes.includes(file.type));
        if (invalidFile) {
            this.customToastService.errorToast(errorMessage, 'Error');
            return;
        }

        // ✔ Add all files — no explicit loop
        fileArray.forEach((file) => {
            this.uploadedFile.push(file);

            this.documentUploadForm.addControl(file.name, new FormControl(file.name, [Validators.required, Validators.maxLength(255)]));
        });
    }

    btnAddClicked() {
        let result = [];
        let invalidFiles: string[] = [];
        const allowedTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/jpg',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        result = this.uploadedFile.map((x) => {
            const controlName = x?.name;
            const control = this.documentUploadForm.controls[controlName];
            if (!allowedTypes.includes(x.type)) {
                invalidFiles.push(x.name);
            }
            let obj = {
                Name: control ? control.value : null,
                file: x,
            };
            return obj;
        });
        if (invalidFiles.length > 0) {
            this.user_utilty.errorModelPopup('One or more of the selected files are not supported.  Please check the allowed file types and try again');
        } else {
            this.modalService.close(result);
            this.documentUploadForm.reset();
        }
    }

    removeUploadedFile(file) {
        this.uploadedFile = this.uploadedFile.filter((x) => x != file);
        this.documentUploadForm.removeControl(file.name);
    }

    consoleForm() {}
}
